import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=2ca1848a&scoped=true&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=2ca1848a&prod&lang=scss&scoped=true&"
import style1 from "./ChatWindow.vue?vue&type=style&index=1&id=2ca1848a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1848a",
  null
  
)

export default component.exports